(function() {
    angular
        .module("usersModule", [
            "ui.router"
        ])
})()
